import initialState from './initialState'

const SET_COMMUNES = function(state, communes) {
    state.communes = communes
}

const SET_CORE_BUSINESS_LIST = function(state, businessList) {
    state.coreBusinessList = businessList
}

const SET_COMPANY_DATA = (state, data) => (state.companyData = data)

const SET_HTML_PPRINT = (state, bool) => (state.htmlPrint = bool)
const SET_CUSTOMER_CREDIT_OPTIONS = (state, options) =>
    (state.customerCreditOptions = options)
const SET_PCH_PAYMENT_CONDITIONS = (state, array) =>
    (state.pchPaymentConditions = array)

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

const SET_MOBILE_SELECTED_PAYMENT_METHOD = (state, id) =>
    (state.mobileSelectedPaymentMethod = id)
const SET_MOBILE_COMMENTARY = (state, commentary) =>
    (state.mobileCommentary = commentary)
const SET_MOBILE_IS_QUOTATION = (state, bool) =>
    (state.mobileIsQuotation = bool)
const SET_MOBILE_STORE_PICKUP = (state, bool) =>
    (state.mobileStorePickup = bool)
const SET_MOBILE_EXPIRATION_DATE = (state, number) =>
    (state.mobileExpirationDate = number)
const SET_MOBILE_CUSTOMER_EMAIL = (state, string) =>
    (state.mobileCustomerEmail = string)

const CLEAR_MOBILE_DATA = state => {
    const {
        mobileSelectedPaymentMethod,
        mobileCommentary,
        mobileIsQuotation,
        mobileStorePickup,
        mobileExpirationDate,
        mobileCustomerEmail,
    } = initialState()
    Object.assign(state, {
        mobileSelectedPaymentMethod,
        mobileCommentary,
        mobileIsQuotation,
        mobileStorePickup,
        mobileExpirationDate,
        mobileCustomerEmail,
    })
}

export default {
    RESET_STATE,
    SET_COMMUNES,
    SET_CORE_BUSINESS_LIST,
    SET_COMPANY_DATA,
    SET_HTML_PPRINT,
    SET_CUSTOMER_CREDIT_OPTIONS,
    SET_PCH_PAYMENT_CONDITIONS,
    SET_MOBILE_COMMENTARY,
    SET_MOBILE_IS_QUOTATION,
    SET_MOBILE_STORE_PICKUP,
    SET_MOBILE_EXPIRATION_DATE,
    SET_MOBILE_CUSTOMER_EMAIL,
    SET_MOBILE_SELECTED_PAYMENT_METHOD,
    CLEAR_MOBILE_DATA,
}
